import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import { useActionsContext } from "../../context/ActionsContext";

const GetActiveBatches = async ({payload})=>{
    const formData = new FormData();
        //  const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
       
  //formData.append('whyus',document.getElementById('whyus').value)
  formData.append('session',payload.session);
  // formData.append('limit', rowsPerPage);

  if(payload.status ==="active"){
    formData.append("status",payload.status);
  }
   if(payload.limit){
            formData.append('limit', payload.limit);
           }



  const res = await axios.post(ENDPOINT+"get-active-batches.php", formData,{
    
  
  headers: {
          'content-type': 'multipart/form-data'
      }
  });
  if(res){
  return res.data
  }
  }
  export default GetActiveBatches